import { useState } from "react";

import { Column } from "@bridgesplit/ui";
import { AbfLoanExpanded, LoopPositionExpanded, RefinanceOption } from "@bridgesplit/abf-react";
import { DialogHeader, Slippage } from "app/components/common";
import { WindType } from "@loopscale/pandora-types";

import IncreasePrincipal from "./IncreasePrincipal";
import SinglePayment from "./payments/SinglePayment";
import { ActionToggleButtons } from "./common";
import { getOptions } from "./util";
import { ManageLoanActions, ManualManageSubActions } from "../side-card/types";
import { useIncreasePrincipal } from "./payments/hooks";
import { UpdateTermsSelectSettings } from "./RefinanceLoan";
export function AdjustDebt({
    loanExpanded,
    isNestedDialogView = false,
    loopPosition
}: {
    loanExpanded: AbfLoanExpanded | undefined;
    isNestedDialogView?: boolean;
    loopPosition: LoopPositionExpanded | undefined;
}) {
    const options = getOptions(ManageLoanActions.AdjustDebt);
    const [selectedAction, setSelectedAction] = useState<ManualManageSubActions>(options[0].value);
    const [isAdjustingTerms, setIsAdjustingTerms] = useState(false);

    const [additionalPrincipal, setAdditionalPrincipal] = useState<number | undefined>(undefined);
    const [selectedOption, setSelectedOption] = useState<RefinanceOption>();
    const [selectedToken, setSelectedToken] = useState<WindType>(WindType.Principal);

    const increasePrincipal = useIncreasePrincipal({ loanExpanded, additionalPrincipal, selectedOption });
    const slippageController = Slippage.useController();

    return (
        <>
            {isAdjustingTerms && (
                <UpdateTermsSelectSettings
                    option={selectedOption}
                    validOptions={increasePrincipal.validOptions}
                    optionsWithOffsets={increasePrincipal.optionsWithOffsets}
                    setOption={setSelectedOption}
                    isNestedDialogView
                    onClose={() => setIsAdjustingTerms(false)}
                />
            )}
            <Slippage.Wrapper {...slippageController.slippageWrapperProps}>
                <Column spacing={3} sx={{ display: isAdjustingTerms ? "none" : undefined }}>
                    <Column spacing={2}>
                        {isNestedDialogView && <DialogHeader headerVariant="h4" header="Adjust debt" description="" />}
                        <ActionToggleButtons
                            value={selectedAction}
                            setValue={setSelectedAction}
                            options={options}
                            isNestedDialogView={isNestedDialogView}
                        />
                    </Column>
                    <Column
                        sx={{
                            display: selectedAction === ManualManageSubActions.IncreasePrincipal ? undefined : "none"
                        }}
                    >
                        <IncreasePrincipal
                            loanExpanded={loanExpanded}
                            loopPosition={loopPosition}
                            setIsAdjustingTerms={setIsAdjustingTerms}
                            increasePrincipalQuote={increasePrincipal}
                            additionalPrincipal={additionalPrincipal}
                            setAdditionalPrincipal={setAdditionalPrincipal}
                            setSelectedOption={setSelectedOption}
                            isNestedDialogView={isNestedDialogView}
                        />
                    </Column>
                    {selectedAction === ManualManageSubActions.DecreasePrincipal && (
                        <SinglePayment
                            loanExpanded={loanExpanded}
                            slippageController={slippageController}
                            isNestedDialogView={isNestedDialogView}
                            selectedToken={selectedToken}
                            setSelectedToken={setSelectedToken}
                            loopPosition={loopPosition}
                        />
                    )}
                </Column>
            </Slippage.Wrapper>
        </>
    );
}
